import script from "./CardMarket.vue?vue&type=script&setup=true&lang=js"
export * from "./CardMarket.vue?vue&type=script&setup=true&lang=js"

import "./CardMarket.vue?vue&type=style&index=0&id=5553bb4f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5553bb4f"]])

export default __exports__